import { render, staticRenderFns } from "./GenerateFileModule.vue?vue&type=template&id=2d316144&scoped=true"
import script from "./GenerateFileModule.vue?vue&type=script&lang=js"
export * from "./GenerateFileModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d316144",
  null
  
)

export default component.exports